import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TreoMessageComponent } from './message.component';
import { TsButtonModule } from 'tsui';

@NgModule({
  declarations: [TreoMessageComponent],
  imports: [CommonModule, TsButtonModule, MatIconModule],
  exports: [TreoMessageComponent],
})
export class TreoMessageModule {}
